import React from 'react';
import NumberFormat from 'react-number-format';
import TextField from 'material-ui/TextField';

const PriceStep = ({ fields, assignRef, onInputKeyDown }) => (
  <div className="step-content">
    <h2>Mánaðarleiga</h2>
    <p>Hvað viltu fá mikið ca$h á mánuði fyrir eignina þína?</p>
    <div className="input-wrapper price-input">
      <TextField
        value={fields.price.value}
        ref={assignRef ? c => assignRef('price', c) : null}
        onKeyDown={onInputKeyDown}
        pattern="[0-9]*"
        type="number"
        min="0" hintText="300.000"
        fullWidth
      >
        <NumberFormat {...fields.price} thousandSeparator="." />
      </TextField>
      <span>kr.</span>
    </div>
  </div>
);

PriceStep.propTypes = {
  fields: React.PropTypes.object.isRequired,
  assignRef: React.PropTypes.func,
  onInputKeyDown: React.PropTypes.func,
};

export default PriceStep;



// WEBPACK FOOTER //
// ./src/browser/steps/PriceStep/PriceStep.js